export const secondary = {
  50: "#f3faf4",
  100: "#e0f2e3",
  200: "#ccebd0",
  300: "#b8e3bd",
  400: "#a8dcae",
  500: "#99d5a0",
  600: "#91d09a",
  700: "#8CCC94",
  800: "#7bc486",
  900: "#5fb872",
};
